import {FC, MouseEvent, useCallback, useEffect, useState} from 'react';
import ruLocale from 'date-fns/locale/ru';
import WebDataRocks from '@webdatarocks/webdatarocks';
import dayjs from 'dayjs';

import {Calendar, DateRangePicker, DateRangePickerProps} from 'react-date-range';
import {Button, Menu, Stack, Typography, styled} from '@mui/material';
import {useRecoilValueLoadable} from 'recoil';
import {reportDataQueryFamily} from '../../../store/reports/selectors';
import {useParams} from 'react-router-dom';
import Fallback from '../../../ui/fallback/Fallback';
import {DATE_FORMAT} from '../../../shared/constants';

interface IReport {
  report: any;
}

function customizeToolbar(toolbar: any) {
  // Get all tabs from the toolbar
  const tabs = toolbar.getTabs();
  toolbar.getTabs = function () {
    // Delete the first tab
    delete tabs[0];
    delete tabs[1];
    delete tabs[2];

    return tabs;
  };
}

const selectionRange = {
  startDate: new Date(),
  endDate: new Date(),
  key: 'selection',
};

const StyledDateRangePicker = styled(DateRangePicker)<DateRangePickerProps>(({theme}) => ({
  '& .rdrDefinedRangesWrapper': {
    display: 'none',
  },
}));

export const Report: FC<IReport> = ({report}) => {
  const {id} = useParams();
  const [stateForView, setStateForView] = useState([selectionRange]);
  const [stateForQuery, setStateForQuery] = useState([selectionRange]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [clickedMenuBtn, setClickedMenuBtn] = useState<string | null>(null);
  const [date, setDate] = useState(new Date());
  const {contents: reportDataContents, state: reportDataState} = useRecoilValueLoadable(
    reportDataQueryFamily({
      id: id as string,
      timeStamp: stateForQuery
        ? {beginDate: stateForQuery[0].startDate.toISOString(), endDate: stateForQuery[0].endDate.toISOString()}
        : date
          ? {momentDate: date.toISOString()}
          : {},
    }),
  );

  const handleClick = useCallback((event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setClickedMenuBtn(event.currentTarget.id);
  }, []);

  const handleSelect = (date: any) => {
    console.log(date);
    setDate(date);
  };

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const open = Boolean(anchorEl);

  const canShowTable =
    (report.timeType === 'NOW' || date || stateForQuery) && reportDataState === 'hasValue' && clickedMenuBtn;

  useEffect(() => {
    canShowTable &&
      new WebDataRocks({
        container: '#wdr-component',
        beforetoolbarcreated: customizeToolbar,
        toolbar: true,
        report: {
          dataSource: {
            data: Array.isArray(reportDataContents.data) ? reportDataContents.data : [],
          },
        },
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportDataState, reportDataContents]);

  return (
    <Stack sx={{px: 4, py: 4}} spacing={3}>
      {report.timeType !== 'NOW' && (
        <Stack direction="row" spacing={2}>
          <Button
            id={report.timeType}
            sx={{whiteSpace: 'nowrap', width: 'fit-content'}}
            onClick={handleClick}
            variant="contained"
          >
            {report.timeType === 'PERIOD' ? 'Выбрать период' : 'Выбрать дату'}
          </Button>
          {clickedMenuBtn && stateForQuery[0].startDate.toISOString() !== stateForQuery[0].endDate.toISOString() && (
            <Typography>{`${dayjs(stateForQuery[0].startDate).format(DATE_FORMAT)} - ${dayjs(stateForQuery[0].endDate).format(DATE_FORMAT)}`}</Typography>
          )}
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
              sx: {minWidth: '164px', p: 0},
            }}
          >
            <li>
              {report.timeType === 'PERIOD' ? (
                <StyledDateRangePicker
                  ranges={stateForView}
                  onChange={(item: any) => {
                    setStateForView([item.selection]);
                    if (item.selection.startDate.toISOString() !== item.selection.endDate.toISOString())
                      setStateForQuery([item.selection]);
                  }}
                  moveRangeOnFirstSelection={false}
                  editableDateInputs
                  startDatePlaceholder="Начальная дата"
                  endDatePlaceholder="Конечная дата"
                  locale={ruLocale}
                />
              ) : (
                <Calendar date={date} onChange={handleSelect} locale={ruLocale} />
              )}
            </li>
          </Menu>
        </Stack>
      )}
      <Stack>
        <div id="wdr-component"></div>
        {reportDataState === 'loading' && <Fallback />}
      </Stack>
    </Stack>
  );
};
